import apiCreator from './util/ApiCreator';
const api = apiCreator('/api/dealer-portal/dealer/resale-certificates');

export default {
    getResaleCertificates () {
        return api.get('');
    },
    deleteResaleCertificate (id) {
        return api.delete(`/${id}`);
    },
    postResaleCertificate(files, data) {
        return api.post('', files, { params : { dto : data }});
    },
};
